<template>
  <div class="line">
    <div id="rule">
      <div class="shadow">
        <div
          class="rule-section"
          v-on:click="toggleShow"
          v-bind:class="{
            pinkBackground: rule.pinkBackground,
            blueBackground: !rule.pinkBackground,
          }"
        >
          <div class="container">
            <div class="unselectable">{{ rule.header }}</div>
            <img
              class="path"
              :src="path"
              v-bind:class="{
                'icon-arrow-down': isRotated,
                'icon-arrow-left': !isRotated,
              }"
            />
          </div>
        </div>
      </div>
      <transition
        name="expand"
        v-for="(content, index) in rule.contents"
        :key="index"
      >
        <div
          v-if="isShowing"
          :class="{ 'reverse-animation': isShowing }"
          v-html="content + '<br>'"
          class="rule-content"
        ></div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "rule",
  props: ["rule"],
  data() {
    return {
      rotation: "rotation-down",
      isRotated: false,
      isShowing: false,
      path: require("@/assets/images/back2.svg"),
    };
  },
  methods: {
    toggleShow: function() {
      this.isShowing = !this.isShowing;
      this.isRotated = !this.isRotated;
    },
  },
};
</script>

<style lang="scss" scoped>
#rule {
  margin-bottom: 7vh;
}

.background {
  background-color: #0d2a4c;
}

.path {
  height: 4vh;
  width: 10vw;
  filter: invert(91%) sepia(5%) saturate(619%) hue-rotate(185deg)
    brightness(106%) contrast(97%);
  z-index: 1000;
  position: relative;
}

.line {
  margin-left: 12%;
  padding-top: 0;
  padding-left: 0;
  border-left: 4px solid #edf6fb;
}

.pinkBackground {
  background-color: #f37298;
}

.blueBackground {
  background-color: #0d9599;
}
.rule-section {
  height: 9vh;
  width: 70vw;
  margin-left: -0.1vw;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  clip-path: polygon(100% 0, 97.5% 50%, 100% 98%, 0 100%, 0 0);
}

.shadow {
  filter: drop-shadow(5px 3.5px 7px rgba(50, 50, 0, 0.5));
}

.unselectable {
  width: 100vw;
  min-width: 60vw;
}

.rule-content {
  width: 80%;
  background-color: #0d2a4c;
  color: #edf6fb;
  max-height: 250rem;
  overflow: hidden;
  padding: 1vw;
  font-size: calc(15px + (40 - 15) * ((100vw - 1024px) / (3840 - 1024)));
}

.container {
  display: flex;
  position: relative;
  top: 25%;
  padding: 0;
  margin: 0;
  justify-content: space-between;
  font-size: calc(20px + (50 - 20) * ((100vw - 1024px) / (3840 - 1024)));
}

.icon-arrow-down {
  transform: rotate(-90deg);
  transition: transform 0.1s linear;
}

.icon-arrow-left {
  transform: rotate(0deg);
  transition: transform 0.1s linear;
}

.expand-enter-active {
  transition: all 0.7s;
  padding: 1vw;
}

.expand-enter {
  max-height: 0px;
  padding: 1vw;
}

.expand-leave-active {
  transition: all 0.3s;
  padding: 1vw;
}

.expand-leave-to {
  padding: 1vw;
  max-height: 0px;
}

.i-custom {
  float: right;
}

.unselectable {
  color: #edf6fb;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

@media screen and (max-width: 1024px) {
  .rule-section {
    width: 85vw;
    height: 8vh;
    text-align: initial;
    overflow-wrap: break-word;
    clip-path: polygon(100% 0, 94% 50%, 100% 100%, 0 100%, 0 0);
  }

  .rule-content {
    font-size: 2vh;
    padding-left: 3vw;
  }

  .line {
    margin-left: 7%;
  }

  .path {
    position: relative;
    left: -5vw;
  }

  .unselectable {
    position: relative;
    left: 2%;
    width: 80%;
    font-size: 3.4vw;
  }
}
</style>
